import React from 'react';
import { Typography, Grid, Box } from '@mui/material';

const SuccessStories = () => {
  return (
    <section id="success" className="whitepaper-section">
      <Typography variant="h2" className="section-title">
        Success Stories
      </Typography>

      <Box className="success-story">
        <Typography variant="h4" gutterBottom sx={{ color: '#10b981', fontWeight: 700 }}>
          Global Investment Bank
        </Typography>
        <Typography variant="body1" sx={{ fontSize: '1.1rem', mb: 2, color: '#e0e7ef', lineHeight: 1.7 }}>
          <strong>Challenge:</strong> $60M annual Splunk costs for 75TB daily data across 150 countries
        </Typography>
        <Typography variant="body1" sx={{ fontSize: '1.1rem', mb: 3, color: '#e0e7ef', lineHeight: 1.7 }}>
          <strong>Solution:</strong> Deployed Confluent as central data fabric with intelligent filtering to multiple analytics platforms
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={3}>
            <Box className="stat-card">
              <Typography className="stat-value">$42M</Typography>
              <Typography className="stat-label">Annual Savings (70%)</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box className="stat-card">
              <Typography className="stat-value">2.1M</Typography>
              <Typography className="stat-label">Events/Second</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box className="stat-card">
              <Typography className="stat-value">99.99%</Typography>
              <Typography className="stat-label">Uptime SLA</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box className="stat-card">
              <Typography className="stat-value">18 months</Typography>
              <Typography className="stat-label">Payback Period</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box className="success-story">
        <Typography variant="h4" gutterBottom sx={{ color: '#60a5fa', fontWeight: 700 }}>
          Healthcare Network (8,500 beds)
        </Typography>
        <Typography variant="body1" sx={{ fontSize: '1.1rem', mb: 2, color: '#e0e7ef', lineHeight: 1.7 }}>
          <strong>Challenge:</strong> HIPAA compliance gaps and ransomware detection delays with legacy SIEM
        </Typography>
        <Typography variant="body1" sx={{ fontSize: '1.1rem', mb: 3, color: '#e0e7ef', lineHeight: 1.7 }}>
          <strong>Solution:</strong> Real-time correlation engine on Confluent analyzing EDR, network, and medical device logs
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={3}>
            <Box className="stat-card">
              <Typography className="stat-value">3 min</Typography>
              <Typography className="stat-label">Ransomware Detection (vs 30min)</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box className="stat-card">
              <Typography className="stat-value">$8.2M</Typography>
              <Typography className="stat-label">Breach Cost Avoidance</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box className="stat-card">
              <Typography className="stat-value">100%</Typography>
              <Typography className="stat-label">HIPAA Audit Trail</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box className="stat-card">
              <Typography className="stat-value">92%</Typography>
              <Typography className="stat-label">False Positive Reduction</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box className="success-story">
        <Typography variant="h4" gutterBottom sx={{ color: '#f59e0b', fontWeight: 700 }}>
          SaaS Provider (200M users)
        </Typography>
        <Typography variant="body1" sx={{ fontSize: '1.1rem', mb: 2, color: '#e0e7ef', lineHeight: 1.7 }}>
          <strong>Challenge:</strong> Zero Trust implementation requiring real-time access decisions at massive scale
        </Typography>
        <Typography variant="body1" sx={{ fontSize: '1.1rem', mb: 3, color: '#e0e7ef', lineHeight: 1.7 }}>
          <strong>Solution:</strong> Confluent streaming identity/device context to policy enforcement points
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={3}>
            <Box className="stat-card">
              <Typography className="stat-value">500K</Typography>
              <Typography className="stat-label">Policy Decisions/Second</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box className="stat-card">
              <Typography className="stat-value">&lt;10ms</Typography>
              <Typography className="stat-label">Decision Latency</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box className="stat-card">
              <Typography className="stat-value">85%</Typography>
              <Typography className="stat-label">Lateral Movement Blocked</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box className="stat-card">
              <Typography className="stat-value">Zero</Typography>
              <Typography className="stat-label">Breach Incidents</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </section>
  );
};

export default SuccessStories;
